

<div>
    <div class="hdg hdg_2" style="margin-bottom: 5px;">Request Account</div>
    {{#if content}}<p class="bdcpy">{{removeMarkup content}}</p>{{/if}}
</div>
<form class="sfForm js-element--requestForm" id="request-account-form" action="">
    <div class="sfForm-row sfForm-row_2up">
        <div class="sfForm-row-item isRequired" id="firstName">
            <label class="sfForm-lbl" for="firstName">First Name</label>
            <input class="sfForm-input required" name="First Name" id="firstName" type="text">
        </div>
        <div class="sfForm-row-item isRequired" id="lastName">
            <label class="sfForm-lbl" for="lastName">Last Name</label>
            <input class="sfForm-input required" name="Last Name" id="lastName" type="text">
        </div>
    </div>
    <div class="sfForm-row">
        <div class="sfForm-row-item" id="company">
            <label class="sfForm-lbl" for="company">Company</label>
            <input class="sfForm-input" name="Company" id="company" type="text">
        </div>
    </div>
    <div class="sfForm-row">
        <div class="sfForm-row-item isRequired" id="email">
            <label class="sfForm-lbl" for="email">Email</label>
            <input class="sfForm-input required" name="Email" id="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}$" type="email">
        </div>
    </div>
    {{#if metaDataOptions}}
        {{#each metaDataOptions}}
            <div class="sfForm-row">
                <div class="sfForm-row-item{{#if isRequired}} isRequired{{#with (lookup ../errors @index)}} sfForm-row-item_hasErrors{{/with}}{{/if}}" id="{{id}}">
                    <label class="sfForm-lbl" for="{{label}}">{{label}}</label>
                    {{#if isSelect}}
                        <select class="sfForm-input required js-element--userMetadata" data-metadata-label="{{label}}" name="{{label}}" id="{{label}}">
                            <option value="">-- Select an Option --</option>
                            {{#each options}}
                                <option value="{{value}}" {{#ifEquals ../value value}}selected="selected"{{/ifEquals}}>{{label}}</option>
                            {{/each}}
                        </select>
                    {{/if}}
                    {{#unless isSelect}}
                        {{#unless isTextarea}}
                            <input type="{{#if isCheckbox}}checkbox{{/if}}{{#if isDate}}date{{/if}}{{#if isText}}text{{/if}}"{{#if isCheckbox}}{{#if value}}checked{{/if}}{{/if}} class="sfForm-input js-element--userMetadata" data-metadata-label="{{label}}" name="{{label}}" id="{{label}}"{{#if value}}value="{{value}}"{{/if}} >
                        {{/unless}}
                    {{/unless}}
                    {{#if isTextarea}}
                        <textarea class="sfForm-input js-element--userMetadata" data-metadata-label="{{label}}" name="{{label}}" id="{{label}}" cols="30" rows="10">{{#if value}}{{value}}{{/if}}</textarea>
                    {{/if}}
                    <div class="sfForm-msg sfForm-msg_error">{{lookup ../errors @index}}</div>
                </div>
            </div>
        {{/each}}
    {{/if}}
    <div class="sfForm-row">
        <div class="sfForm-row-item">
            <button type="button" class="btn btn_reversed" onclick="sendFormEmail('request-account-form', 'status')">Submit</button>
        </div>
    </div>
</form>